import { redirect } from 'react-router';

import { getIdentity } from './firebase.tsx';

export async function requiresAuth() {
  const identity = await getIdentity();
  if (!identity) {
    throw redirect('/signin');
  }
  return identity;
}
